import { Feature } from "common/types";

import { useFeatures } from "client/clinics/hooks";

import CategoryPage from "./CategoryPage";
import CategoryPageV2 from "./CategoryPageV2";

const CategoryPageSwitch = () =>
  useFeatures()[Feature.CategoryPageV2] ? <CategoryPageV2 /> : <CategoryPage />;

export default CategoryPageSwitch;
